import React from 'react';
import useTranslate from '../../hooks/useTranslate';
import Header from '../../components/Header/Header';

const CustomerCare = () => {
    const t = useTranslate();
    return (
        <>
            <Header forceHideHamburger />
            <div className="customer_care_info">
                <h1>{t('customer_care')}</h1>
                <p>{t('telephone')}: +359 24928370</p>
                <p>{t('electronic_mail.')}: playnixzone.bg@silverlines.info</p>
            </div>
        </>
    );
};

export default CustomerCare;
